import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { Header, Icon } from 'semantic-ui-react';
import { entityUrl } from '@/constants/urls';
import entityIcons from '@/constants/images';

const RequestSourceHeader = ({
  category,
  code,
  name,
  className,
}) => {
  const intl = useIntl();
  return (
    <Header
      as="a"
      href={entityUrl(category, code, '#')}
      className={clsx('aridhia-request-source-header primary aridhia-h2 mb-0', className)}
      rel="noopener noreferrer"
    >
      <Icon name={entityIcons[category]} />
      <Header.Content content={intl.formatMessage({ id: 'tabs.request.access.to' }, { name })} />
    </Header>
  );
};

export default RequestSourceHeader;
